import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-white px-4 pb-5 pt-4" data-id="element-80" data-mp="9kjvgl9o4y23">
      <div className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="9lbkfd8rfxje">
        <h1 className="mb-2 font-display text-[21px] font-extrabold uppercase leading-tight text-brand-ink sm:text-4xl" style={{
        fontSize: "18px"
      }} data-id="element-82" data-mp="4m8mecr76rkx">
          The Complete Installation &amp; Business System for Future Smart Home Installers
        </h1>
        <p className="mx-auto mb-1 max-w-2xl font-display text-sm font-semibold leading-snug text-brand-ink sm:text-base" style={{
        fontSize: "13px"
      }} data-id="element-83" data-mp="x8jo5qqjiyjb">
          Stop piecing together Smart Home installation from scattered tutorials.
        </p>
        <p className="mx-auto mb-2 max-w-2xl text-sm font-normal leading-snug text-brand-muted sm:text-base" style={{
        fontSize: "12px"
      }} data-id="element-84" data-mp="3d2bidl8y6rtf">
          Learn how complete residential Smart Home systems are planned, connected, automated,
          tested, and delivered — step by step inside one structured system.
        </p>
        
        <a href={OFFER_ANCHOR} className="mb-3 block cursor-pointer" aria-label="Go to the offer" data-id="element-85" data-mp="39acyeqprnqu2">
          <img src={PRODUCT_IMG} alt="Smart Home Installer Pro complete 6-in-1 system box set" className="mx-auto w-full max-w-sm object-contain drop-shadow-2xl transition-transform duration-200 hover:scale-[1.02] sm:max-w-md" data-id="element-86" data-mp="3e9fs5f0aqamq" />
        </a>
        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-87" data-mp="359szpipjof5t">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-88" data-mp="2qkmv1f7xtwqj">
          <div className="flex items-center gap-1" data-id="element-89" data-mp="2vj7sx7zpw4bt">
            <StarIcon className="h-4 w-4 fill-brand-amber text-brand-amber" data-id="element-90" data-mp="2hix0w1mo8jp2" />
            <span data-id="element-91" data-mp="2lkilya9d04ac">⭐⭐⭐⭐⭐ 4.9/5 — Verified Student Reviews</span>
          </div>
          <span className="hidden text-brand-line sm:inline" data-id="element-92" data-mp="2lmv3wnf4aene">•</span>
          <div className="flex items-center gap-1" data-id="element-93" data-mp="s2tbjfzvhzn3">
            <ShieldCheckIcon className="h-4 w-4 text-brand-orange" data-id="element-94" data-mp="nbl4urpxgsdm" />
            <span data-id="element-95" data-mp="n98cdkmjmzmb">🛡️ 7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}